import { subDays, addDays } from "date-fns";

const TargetConfigs = {
  master: {
    title: "Target",
    apiName: "masterdata/target",
    orderBy: "id",
    orderMethod: "ASC",
    additionalParams: { 
      // add_params
    },
  },
  dialog: {
    title: "Target",
    isForm: false,
  },

  columns: [
    // add_configs
    {
      name: "Label",
      field: "label",
      type: "text_plain",
      table: true,
      filter: true,
      editor: true,
      object_name: "",
      object_field: "",
    },
    {
      name: "Value",
      field: "value",
      type: "number_plain",
      editor: true,
      align: "right",
      object_name: "",
      object_field: "",
      table: true,
    },
  ],
};

export default TargetConfigs;
